import { render, staticRenderFns } from "./performanceSetting.vue?vue&type=template&id=2a2e4d64&scoped=true"
import script from "./performanceSetting.vue?vue&type=script&lang=js"
export * from "./performanceSetting.vue?vue&type=script&lang=js"
import style0 from "./performanceSetting.vue?vue&type=style&index=0&id=2a2e4d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e4d64",
  null
  
)

export default component.exports